import { useEffect, useState } from 'react';
import { loadPlanAccessMatrix, isComingSoon } from '../lib/planAccessMatrix';
import { getServiceBySlug } from '../data/services';

// ─────────────────────────────────────────
// useComingSoon, returns whether a service (by services.ts slug) has
// been flagged as "coming soon".
//   undefined → matrix still loading (show nothing / neutral state)
//   true      → service is coming soon (disable CTAs, show badge)
//   false     → service is live
//
// Priority: static ServiceDef.comingSoon OR admin matrix _meta flag.
// ─────────────────────────────────────────

export function useComingSoon(catalogSlug: string | undefined): boolean | undefined {
  const [value, setValue] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (!catalogSlug) {
      setValue(false);
      return;
    }

    // Check static flag first, if set, mark immediately without waiting for matrix
    const staticFlag = getServiceBySlug(catalogSlug)?.comingSoon;
    if (staticFlag) {
      setValue(true);
      return;
    }

    let active = true;
    loadPlanAccessMatrix().then(matrix => {
      if (!active) return;
      setValue(isComingSoon(matrix, catalogSlug));
    });
    return () => { active = false; };
  }, [catalogSlug]);

  return value;
}
